import { render, staticRenderFns } from "./SiteWrapper.vue?vue&type=template&id=5081aff4&"
import script from "./SiteWrapper.vue?vue&type=script&lang=js&"
export * from "./SiteWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports